// bm-design-system: textarea primitive
import * as React from "react";
import { cn } from "@/lib/utils";

export interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  /** Monospace, no spellcheck — for code, SQL, and other machine text. */
  mono?: boolean;
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, mono = false, spellCheck, ...props }, ref) => {
    return (
      <textarea
        ref={ref}
        spellCheck={spellCheck ?? (mono ? false : undefined)}
        className={cn(
          "form-control form-control-textarea",
          mono && "font-mono text-xs leading-relaxed",
          className,
        )}
        {...props}
      />
    );
  },
);
Textarea.displayName = "Textarea";

export { Textarea };
